import React, { Suspense } from "react";

// Lazy: the public pages' bundle must not grow by the admin, Auth0 and Material dialogs.
// The harness condition is written inline (not via a const) so webpack can evaluate it at
// build time and drop the dev-only harness chunk from production builds entirely.
const Admin =
  process.env.NODE_ENV !== "production" && process.env.REACT_APP_ADMIN_HARNESS === "1"
    ? React.lazy(() => import("./dev/AdminHarness"))
    : React.lazy(() => import("./AdminApp"));

export default function AdminEntry() {
  return (
    <Suspense fallback={<p style={{ padding: 16 }}>Betöltés…</p>}>
      <Admin />
    </Suspense>
  );
}
